// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qhNp","delete":"styles_delete__2lKSa","update":"styles_update__3nuU3","add":"styles_add__1v0Z0"};